import { QuickActionApi, Tag } from '@clients/myTrips' // eslint-disable-line no-unused-vars
import appendCredentials from '@util/appendCredentials'
import getBasePath from '@util/path'
import { AxiosPromise } from 'axios' // eslint-disable-line no-unused-vars

let basePath = getBasePath() + '/my-trips'

export default class ExtendedQuickActionApi extends QuickActionApi {
  getQuickActionTags (options?: any): AxiosPromise<Array<Tag>> {
    const optionsParam = appendCredentials(options)
    optionsParam.basePath = basePath
    return super.getQuickActionTags(undefined, optionsParam)
  }
}
